import type {
	Components,
} from '@mui/material'

export const materialUIToggleButtonGroupTheme: {
	components: Components
} = {
	components: {
		MuiToggleButtonGroup: {
			styleOverrides: {
				root: {
				},
			},
		},
		MuiToggleButton: {
			styleOverrides: {
			},
		},
	},
}
